export const Money = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0013 6.14567V5.28919M10.0013 13.854V14.7105M11.8561 7.43039C11.4858 6.91839 10.7938 6.57391 10.0013 6.57391H9.76339C8.71223 6.57391 7.8601 7.25562 7.8601 8.09655V8.16192C7.8601 8.76341 8.28489 9.31327 8.95738 9.58227L11.0452 10.4174C11.7177 10.6864 12.1425 11.2363 12.1425 11.8378C12.1425 12.7148 11.2538 13.4258 10.1575 13.4258H10.0013C9.20875 13.4258 8.51678 13.0813 8.14655 12.5693M17.7096 9.99984C17.7096 14.257 14.2585 17.7082 10.0013 17.7082C5.74411 17.7082 2.29297 14.257 2.29297 9.99984C2.29297 5.74264 5.74411 2.2915 10.0013 2.2915C14.2585 2.2915 17.7096 5.74264 17.7096 9.99984Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Money
